import script from "./PatientDentistry.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientDentistry.vue?vue&type=script&setup=true&lang=js"

import "./PatientDentistry.vue?vue&type=style&index=0&id=02611a18&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02611a18"]])

export default __exports__